import { trpc } from "../trpc";

/**
 * Duplicates a template. The copy is named and owned by the templates backend
 * (see the duplicate endpoint), so nothing but the source id is sent.
 *
 * Invalidates every cached `search` variant rather than inserting the copy
 * optimistically: the list is paginated and sorted by `-createdAt` upstream, so
 * a local insert would fight the server ordering.
 */
export function useDuplicateTemplate() {
  const utils = trpc.useUtils();

  return trpc.template.duplicate.useMutation({
    onSuccess() {
      utils.template.search.invalidate();
    },
  });
}
